"use client";

import { useExploreRoute } from "../_lib/explore-route-context";
import type { ExploreWorkflowCard } from "../types";
import { SectionHeader } from "./section-header";
import { WorkflowCard } from "./workflow-card";

interface WorkflowsSectionProps {
  workflows: ExploreWorkflowCard[];
  className?: string;
}

export function WorkflowsSection({
  workflows,
  className,
}: WorkflowsSectionProps) {
  const { exploreBase } = useExploreRoute();

  return (
    <section className={className}>
      <SectionHeader
        seeAllHref={`${exploreBase}/stories`}
        seeAllLabel="Step-by-step guides →"
        title="Workflows you can try today"
      />

      <div className="sm:-mx-3 grid gap-5 sm:grid-cols-2 sm:p-3">
        {workflows.map((workflow) => (
          <WorkflowCard
            exploreBase={exploreBase}
            key={workflow.id}
            workflow={workflow}
          />
        ))}
      </div>
    </section>
  );
}
